import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendButtonClickSoundCommand } from '../../helpers/web_to_client'

import styles from './LinkButton.scss'

class LinkButton extends React.PureComponent {
    static propTypes = {
        isDisabled: PropTypes.bool,
        isFocusOn: PropTypes.bool,
        buttonClickSoundId: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        tooltipId: PropTypes.string,
        tabIndex: PropTypes.number,
    }

    componentDidMount() {
        if (this.props.isFocusOn) {
            this._button.focus()
        }
    }

    handleClick = (event) => {
        this.props.onClick(event)
    }

    handleMouseDown = () => {
        sendButtonClickSoundCommand(this.props.buttonClickSoundId)
    }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles.isDisabled]: this.props.isDisabled,
        })

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        const tabIndexAttr = this.props.tabIndex !== undefined ? {
            tabIndex: this.props.tabIndex,
        } : {}

        return (
            <button
                ref={(c) => this._button = c}
                className={classNameBase}
                onClick={this.props.isDisabled ? null : this.handleClick}
                onMouseDown={this.props.isDisabled ? null : this.handleMouseDown}
                onMouseEnter={this.props.isDisabled ? null : sendHoverSoundCommand}
                {...tabIndexAttr}
                {...dataAttrs}
            />
        )
    }
}

export default LinkButton



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/LinkButton/LinkButton.jsx